import { ICON } from '../../config/icons';
import './DataItem.scss';

interface DataItemProps {
  label: string;
  icon: (typeof ICON)[keyof typeof ICON];
}

export const DataItem = ({ label, icon }: DataItemProps) => {
  // TODO: wire up off icon
  const renderIcon = () => {
    if (typeof icon === 'string') {
      return (
        <div className="data-item--icon">
          <img src={icon} alt={`${label} icon`} className="data-item--icon-image" />
        </div>
      );
    }
    return <></>;
  };
  return (
    <div className={`data-item`}>
      <div className="data-item--container">
        <div className="data-item--label">
          {renderIcon()} <span>{label}</span>
        </div>
      </div>
    </div>
  );
};
